import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { setBackdrop, useAsyncDeleteAction } from "common-frontend-components";
import { categoriesStore } from "../../../stores/useCategoriesStore";
import { callDeleteCategoryAsync } from "../../../apis/categories";
import { Box, Chip, Grid } from "@mui/material";
import { CreateCategory } from "./CreateCategory";
import Typography from "@mui/material/Typography";
import { textColor } from "../../../assets/styles/colors";
import { textFieldStyle } from "../../../assets/styles/styles";
import { EditCategory } from "./EditCategory";
const CategoryChip = ({ category }) => {
    const { handleClick } = useAsyncDeleteAction({
        name: 'category',
        value: category.name,
        onClick: async () => {
            setBackdrop(true);
            callDeleteCategoryAsync(category.id)
                .then(() => { categoriesStore.setCategories(categoriesStore.getCategories().filter(i => category.id !== i.id)); })
                .finally(() => { setBackdrop(false); });
        }
    });
    return (_jsx(Chip, { label: category.name, sx: { ...textFieldStyle, backgroundColor: '#ffffff33' }, onDelete: handleClick }, void 0));
};
export const CategoryManager = () => {
    const categories = categoriesStore.useCategories();
    return (_jsxs("div", { children: [_jsx(CreateCategory, {}, void 0), categories.length > 0 &&
                _jsxs(_Fragment, { children: [_jsx(Box, { sx: { paddingTop: 3, paddingBottom: 3 }, children: _jsx(EditCategory, {}, void 0) }, void 0), _jsx(Typography, { sx: { fontSize: '1.5rem', paddingBottom: 1, paddingTop: 3, color: textColor + '55' }, color: "text.secondary", gutterBottom: true, children: "Categories" }, void 0)] }, void 0), _jsx(Grid, { container: true, spacing: 1, children: categories.map(i => _jsx(Grid, { item: true, children: _jsx(CategoryChip, { category: i }, void 0) }, i.id)) }, void 0)] }, void 0));
};
//# sourceMappingURL=CategoryManager.js.map